module.exports = __webpack_public_path__ + "static/media/finance_bg.fd505a82.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/finance_bg.png
// module id = 1111
// module chunks = 21